{
    "SidebarMenu_Reporting_Reporting": "Análises",
    "SidebarMenu_Reporting_Insights": "Percepções",
    "SidebarMenu_Reporting_Presence": "Presença",
    "SidebarMenu_FastProvisioning_EnterpriseManagement": "Adicionar Empresa Empresarial +",
    "SidebarMenu_FastProvisioning_UserManagement": "gestão de utilizadores",
    "SidebarMenu_FastProvisioning_QueueManagement": "gestão de filas",
    "SidebarMenu_Admin_Devices": "Dispositivos",
    "SidebarMenu_Admin_Agents": "Agentes",
    "SidebarMenu_Admin_Directory": "Diretório",
    "SidebarMenu_Admin_Codes": "Códigos",
    "SidebarMenu_Admin_Partitions": "Partições",
    "SidebarMenu_Admin_TelephonyServers": "Servidores de Telefonia",
    "SidebarMenu_Admin_CME": "CME",
    "SidebarMenu_Admin_AppUsers": "utilizadors",
    "SidebarMenu_Admin_Recording": "Gravação",
    "SidebarMenu_Admin_Messages": "Mensagens",
    "SidebarMenu_Admin_Database": "base de dados",
    "SidebarMenu_StatusTools_Licences": "Licenças",
    "SidebarMenu_StatusTools_Logging": "Registo",
    "SidebarMenu_StatusTools_LogManagement": "gestão de logs",
    "SidebarMenu_StatusTools_AuditTrail": "Trilha de auditoria",
    "SidebarMenu_StatusTools_TelephoneModuleStatus": "Estado do módulo TelSys",
    "SidebarMenu_StatusTools_CallControl": "controlo de chamadas",
    "SidebarMenu_StatusTools_ServerStatus": "Estado do servidor",
    "NAME": "SidebarMenu",
    "SidebarMenu_Admin_ClientConfig": "Configuração do cliente",
    "SidebarMenu_Admin_CRM_Configuration": "Integração de CRM",
    "SidebarMenu_Reporting_CXScore": "Pontuação CX",
    "SidebarMenu_Admin_Overview": "Visão geral"
}